import { IconType } from 'react-icons' // Importe o tipo base dos ícones
import { Swiper, SwiperSlide } from 'swiper/react'
import { EffectCoverflow, Pagination } from 'swiper/modules'
import { FaGuitar, FaDrum } from 'react-icons/fa'
import {
  GiGuitarBassHead,
  GiBanjo,
  GiMusicalKeyboard,
  GiGuitar
} from 'react-icons/gi'
import { PiGuitarFill } from 'react-icons/pi'

import 'swiper/css'
import 'swiper/css/effect-coverflow'
import 'swiper/css/pagination'

import { Container, CardAula, TituloSecao } from './styles'

type InstrumentoTipo = {
  nome: string
  icon: IconType
  img: string
  descricao: string
}

const instrumentos = [
  { nome: 'Violão', icon: FaGuitar, img: '', descricao: '' },
  { nome: 'Guitarra', icon: GiGuitar, img: '', descricao: '' },
  { nome: 'Teclado', icon: GiMusicalKeyboard, img: '', descricao: '' },
  { nome: 'Contrabaixo', icon: GiGuitarBassHead, img: '', descricao: '' },
  { nome: 'Cavaquinho', icon: GiBanjo, img: '', descricao: '' },
  { nome: 'Ukulelê', icon: PiGuitarFill, img: '', descricao: '' },
  { nome: 'Bateria', icon: FaDrum, img: '', descricao: '' }
]

interface AulasProps {
  aoSelecionar: (instrumento: InstrumentoTipo) => void // Avisa ao TS que essa prop existe!
}

const Aulas = ({ aoSelecionar }: AulasProps) => {
  return (
    <Container>
      <TituloSecao>Nossas Aulas</TituloSecao>
      <Swiper
        effect={'coverflow'}
        grabCursor={true}
        centeredSlides={true}
        slidesPerView={5}
        loop={true}
        coverflowEffect={{
          rotate: 0,
          stretch: 0,
          depth: 100,
          modifier: 2.5,
          slideShadows: false
        }}
        breakpoints={{
          320: { slidesPerView: 1 },
          768: { slidesPerView: 3 }
        }}
        modules={[EffectCoverflow, Pagination]}
      >
        {instrumentos.map((inst, index) => {
          const Icone = inst.icon as React.ComponentType<{ size?: number }>

          return (
            <SwiperSlide key={index}>
              <CardAula>
                {Icone && <Icone size={80} />}
                <h3>{inst.nome}</h3>
                <button onClick={() => aoSelecionar(inst)}>Ver detalhes</button>
              </CardAula>
            </SwiperSlide>
          )
        })}
      </Swiper>
    </Container>
  )
}

export default Aulas
